<mat-form-field class="gwc-masked-input"
	[floatLabel]="formControl.value ? 'always' : 'auto'">
	<mat-label>{{ props.label }}</mat-label>
	<input matInput 
		[mask]="props['mask']"
		[required]="props['required'] ? true : false"
		[prefix]="props['prefix'] || ''"
		[dropSpecialCharacters]="props['dropSpecialCharacters'] ?? true"
		[validation]="props['validation'] || false"
		[formControl]="formControl">
</mat-form-field>
